import { Error } from '../../../../ErrorHandling';
import { Link } from '../../../../Resource/Types';
import { ResourcesListResource } from '../../Shared/Types';

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
  links: ReadonlyArray<Link>;
}

interface Ready {
  kind: 'ready';
  personalResourcesListResource: ResourcesListResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (links: ReadonlyArray<Link>): Loading => ({
  kind: 'loading',
  links,
});

export const ready = (personalResourcesListResource: ResourcesListResource): Ready => ({
  kind: 'ready',
  personalResourcesListResource,
});

export type PersonalResourcesState = Waiting | Loading | Ready | Error;
